import { useState, useEffect } from 'react'

export default function usePDF(fileBlob) {
  const [pdfData, setPdfData] = useState(null)

  useEffect(() => {
    if (!fileBlob) {
      setPdfData(null)
      return
    }

    let isCancelled = false

    async function readFile() {
      try {
        if (fileBlob instanceof Blob) {
          const buffer = await fileBlob.arrayBuffer()
          if (!isCancelled) setPdfData(buffer)
        } else if (fileBlob instanceof ArrayBuffer) {
          setPdfData(fileBlob)
        } else {
          setPdfData(null)
        }
      } catch (e) {
        if (!isCancelled) setPdfData(null)
      }
    }

    readFile()

    return () => {
      isCancelled = true
      setPdfData(null)
    }
  }, [fileBlob])

  return pdfData
}
